module.exports = __webpack_public_path__ + "img/loader.bdcb1c55.svg";